import { Kisi } from "./Kisi";

export class Kurum {
    constructor(
        public vergiNo: string,
        public eposta: string,
        public kisi: Kisi
    ) {}
}